import React, { PureComponent } from 'react';
import { Col, Card, Row } from 'reactstrap';
import WizardFormCreate from './Forms/Create';
import WizardFormConfigure from './Forms/Configure';
import WizardFormImport from './Forms/ImportPosts';
import { connect } from 'react-redux';
import {withTranslation} from "react-i18next";

class Wizard extends PureComponent {

  constructor() {
    super();
    this.state = {
      page: 1,
    };
  }

  nextPage = () => {
    this.setState(prevState => ({ page: prevState.page + 1 }));
  };

  previousPage = () => {
    this.setState(prevState => ({ page: prevState.page - 1 }));
  };

  render() {
    const { page } = this.state;
    const { t } = this.props;

    return (
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <div className="wizard card-body">
              <div className="wizard__steps">
                <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}><p>{t('create.wizard.create.title')}</p></div>
                <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}><p>{t('create.wizard.configure.title')}</p></div>
                <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}><p>{t('create.wizard.import.title')}</p></div>
              </div>
              <div className="wizard__form-wrapper">
                {page === 1 && (
                  <WizardFormCreate nextPage={this.nextPage} />
                )}
                {page === 2 && (
                  <WizardFormConfigure nextPage={this.nextPage} />
                )}
                {page === 3 && (
                  <WizardFormImport />
                )}
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    blogs: state.blogs.blogs
  }
}

export default connect(mapStateToProps)(withTranslation('dashboard')(Wizard));
